import { MovieOpenEditOutlineIcon } from './MovieOpenEditOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 83B13E8A-4202-47CF-B67E-34335B0E5B29
 * name movie-open-edit-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-edit-outline.svg
 * tags
 * - Video / Movie 
 * - Edit / Modify 
 */
export const FilmOpenEditOutlineIcon = MovieOpenEditOutlineIcon;
export default FilmOpenEditOutlineIcon